import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15acee4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alajo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading-2 alajo-heading" }, "Thrift with Halal", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "The most secured way to doing Ajo/Esusu/Adashe", -1))
const _hoisted_4 = { class: "alajo-body d-flex align-items-center" }
const _hoisted_5 = { class: "alajo-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "alajo-right d-none d-md-block" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "alajo-list",
            key: list.heading
          }, [
            _createElementVNode("h3", null, _toDisplayString(list.heading), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.items, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _hoisted_6,
                _createElementVNode("p", null, _toDisplayString(item), 1)
              ], 64))
            }), 128))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: require('@/assets/alajo.png'),
          class: "w-100"
        }, null, 8, _hoisted_8)
      ])
    ])
  ]))
}